class AccordionRow extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    if (this.isAnimating) {
      e.preventDefault();
      return;
    }

    if (this.details.open) {
      e.preventDefault();
      this.close();
    } else {
      e.preventDefault();
      this.open();
    }
  }

  open() {
    this.isAnimating = true;
    this.details.open = true;

    // Close other open accordions within the same section
    const section = this.closest('.shopify-section') || document;
    const otherAccordions = section.querySelectorAll('accordion-row');
    otherAccordions.forEach(accordion => {
      if (accordion !== this && accordion.details.open) {
        accordion.close();
      }
    });

    
    // We need to wait for the next frame to get the correct height if it was just set to open
    requestAnimationFrame(() => {
      const summaryHeight = this.summary.offsetHeight;
      const contentHeight = this.content.scrollHeight;
      const endHeight = summaryHeight + contentHeight;

      this.details.animate([
        { height: `${summaryHeight}px`, overflow: 'hidden' },
        { height: `${endHeight}px`, overflow: 'hidden' }
      ], {
        duration: 400,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      }).onfinish = () => {
        this.details.style.height = '';
        this.isAnimating = false;
      };
    });
  }

  close() {
    this.isAnimating = true;
    const startHeight = this.details.offsetHeight;
    const summaryHeight = this.summary.offsetHeight;
    
    this.details.animate([
      { height: `${startHeight}px`, overflow: 'hidden' },
      { height: `${summaryHeight}px`, overflow: 'hidden' }
    ], {
      duration: 400,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }).onfinish = () => {
      this.details.open = false;
      this.details.style.height = '';
      this.isAnimating = false;
    };
  }
}

customElements.define('accordion-row', AccordionRow);
